import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { createBrowserRouter, RouterProvider } from 'react-router'

import { routes } from './app/routes'
import { I18nProvider } from './i18n/I18nProvider'
import './styles/index.css'

const root = document.getElementById('root')
if (root === null) {
  throw new Error('missing #root element')
}

createRoot(root).render(
  <StrictMode>
    <I18nProvider>
      <RouterProvider router={createBrowserRouter(routes)} />
    </I18nProvider>
  </StrictMode>,
)
